<template>
    <v-dialog v-model="visible" persistent max-width="700px">
        <v-card light>
            <v-card-title class="justify-center">
                <v-spacer/>
                <span class="text-h5">
                    {{ form.id ? 'Edição' : 'Cadastro' }} de Lançamento
                </span>
                <v-spacer/>
            </v-card-title>
            <v-card-text>
                <v-row dense>
                    <v-col cols="12" sm="8">
                        <v-text-field
                            label="Nome"
                            v-model="form.nome"
                            dense
                            outlined
                            hide-details
                        />
                    </v-col>
                    <v-col cols="12" sm="4">
                        <v-text-field
                            label="Valor"
                            v-model.number="form.valor"
                            type="number"
                            step="0.01"
                            min="0"
                            prefix="R$"
                            dense
                            outlined
                            hide-details
                        />
                    </v-col>
                    <v-col cols="12" sm="6">
                        <v-select
                            label="Conta"
                            v-model="form.conta_id"
                            :items="contas"
                            item-text="nome"
                            item-value="id"
                            dense
                            outlined
                            hide-details
                        />
                    </v-col>
                    <v-col cols="12" sm="6">
                        <v-select
                            label="Categoria"
                            v-model="form.categoria_id"
                            :items="categorias"
                            item-text="nome"
                            item-value="id"
                            dense
                            outlined
                            hide-details
                        />
                    </v-col>
                    <v-col cols="12" sm="4">
                        <v-text-field
                            label="Mês de referência"
                            v-model="form.mes_referencia"
                            type="date"
                            dense
                            outlined
                            hide-details
                        />
                    </v-col>
                    <v-col cols="12" sm="4">
                        <v-text-field
                            label="Vencimento"
                            v-model="form.vencimento"
                            type="date"
                            dense
                            outlined
                            hide-details
                        />
                    </v-col>
                    <v-col cols="12" sm="4">
                        <v-text-field
                            label="Pagamento"
                            v-model="form.pagamento"
                            type="date"
                            dense
                            outlined
                            hide-details
                            clearable
                            hint="Preencha para marcar como pago"
                            persistent-hint
                        />
                    </v-col>
                    <v-col cols="12">
                        <v-textarea
                            label="Observação"
                            v-model="form.observacao"
                            dense
                            outlined
                            hide-details
                            rows="2"
                            auto-grow
                        />
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions>
                <v-btn text color="warning" @click="$emit('close')">Cancelar</v-btn>
                <v-spacer/>
                <v-btn color="success" @click="salvar" :loading="loading">
                    <v-icon>mdi-content-save</v-icon>&nbsp;Salvar
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: 'LancamentoForm',

    props: {
        visible: { type: Boolean, default: false },
        formData: { type: Object, default: () => ({}) },
        contas: { type: Array, default: () => [] },
        categorias: { type: Array, default: () => [] },
    },

    data: () => ({
        form: {},
        loading: false,
    }),

    watch: {
        formData(value) {
            this.form = value ? JSON.parse(JSON.stringify(value)) : {};
        },
    },

    methods: {
        salvar() {
            const required = ['nome', 'valor', 'mes_referencia', 'categoria_id', 'conta_id', 'vencimento'];
            for (const k of required) {
                if (this.form[k] === undefined || this.form[k] === null || this.form[k] === '') {
                    alert('Preencha todos os campos obrigatórios');
                    return;
                }
            }

            const payload = {
                nome: this.form.nome,
                valor: Number(this.form.valor),
                mes_referencia: this.form.mes_referencia,
                categoria_id: this.form.categoria_id,
                conta_id: this.form.conta_id,
                vencimento: this.form.vencimento,
                pagamento: this.form.pagamento || null,
                observacao: this.form.observacao || null,
            };

            this.loading = true;
            const id = this.form.id;
            const req = id
                ? this.$http.put(`financeiro-interno/lancamentos/${id}`, payload)
                : this.$http.post('financeiro-interno/lancamentos', payload);

            req.then(() => this.$emit('onCadastro'))
                .catch(e => alert(e?.response?.data?.message || 'Erro ao salvar'))
                .finally(() => (this.loading = false));
        },
    },
};
</script>
